// ── Patrimia i18n ──
// Systeme de traduction leger — pas de lib externe, juste des objets types.
// Utilise le hook useT() pour acceder aux traductions dans les composants.

import { create } from 'zustand'
import { fr, type Translations } from './fr.js'
import { nl } from './nl.js'

const locales: Record<string, Translations> = { fr, nl }

type SupportedLocale = 'fr' | 'nl' | 'de'

interface I18nStore {
  locale: SupportedLocale
  t: Translations
  setLocale: (locale: SupportedLocale) => void
}

function getInitialLocale(): SupportedLocale {
  const saved = localStorage.getItem('patrimia-locale')
  if (saved && saved in locales) return saved as SupportedLocale
  const nav = navigator.language.slice(0, 2)
  if (nav in locales) return nav as SupportedLocale
  return 'fr'
}

export const useI18n = create<I18nStore>((set) => {
  const initial = getInitialLocale()
  return {
    locale: initial,
    t: locales[initial] || fr,
    setLocale: (locale) => {
      localStorage.setItem('patrimia-locale', locale)
      set({ locale, t: locales[locale] || fr })
    },
  }
})

/** Raccourci : acces direct aux traductions */
export function useT() {
  return useI18n((s) => s.t)
}
